export const tipiDocumento = [
	{label: "Carta d'identità", val: "cartaIdentita"},
	{label: "Patente", val: "patente"},
	{label: "Passaporto", val: "passaporto"},
	{label: "Codice STP", val: "codiceSTP"}
]

export const tipiDocumentoCodf = [
	{label: "Codice fiscale", val: "codiceFiscale"},
	{label: "Carta d'identità", val: "cartaIdentita"},
	{label: "Patente", val: "patente"},
	{label: "Passaporto", val: "passaporto"},
	{label: "Codice STP", val: "codiceSTP"}
]

export const tipiDocumentoAnonim = [
	{label: "Carta d'identità", val: "cartaIdentita"},
	{label: "Patente", val: "patente"},
	{label: "Passaporto", val: "passaporto"},
	{label: "Codice STP", val: "codiceSTP"},
	{label: "Utente anonimo*", val: "Utente anonimo*"},
]

export const tipiInfoLavoro = [
	/*0*/"Operatore scolastico",
	/*1*/"Docente",
	/*2*/"Studente",
	/*3*/"Operatore sanitario",
	/*4*/"Forze dell' ordine",
	/*5*/"Disoccupato",
	/*6*/"Pensionato",
	/*7*/"Altro",
	/*8*/"Casalinga",
	/*9*/"Badante",
]

export const tipoOpSanitario = [
	"Medico",
	"Infermiere",
	"OSS",
	"Altro",
]

export const tipoForzeOrdine = [
	"Polizia di Stato",
	"Polizia provinciale",
	"Polizia municipale",
	"Polizia penitenziaria",
	"Carabinieri",
	"Guardia di finanza",
	"Vigili del fuoco",
	"Esercito",
	"Marina Militare",
	"Aeronautica Militare",
	"Sanità Militare",
	"Riserva Militare - VFP",
	"Altro",
]

export const tipologieQuarantena = [
	"Isolamento",
	"Quarantena",
	
	"Isolamento - comunità",
	"Quarantena - comunità"
]

export const tipoMonitortaggio = [
	"Manuale",
	"Automatico",
	"Disattivato"
]

export const sintomi = [
	"Febbre > di 37.5°",
	"Tosse",
	"Difficoltà respiratorie o dispnea",
	"Alterazione del gusto",
	"Alterazione dell' olfatto",
	"Mal di testa (cefalea)",
	"Brividi",
	"Dolori muscolari (mialgia)",
	"Astenia",
	"Diarrea",
	"Vomito",
	"Raffreddore",
	"Mal di gola"
]

export const immunodepressioni = [
	"Oncologici in chemioterapia",
	"HIV positivi",
	"trapiantati",
	"in trattamento con farmaci immunodepressivi",
	"in trattamento con farmaci cortisonici",
	"Altro",
]

export const patologie = [
	"diabete",
	"ipertensione",
	"cardiopatia",
	"asma",
	"bronchiti croniche",
	"Altro",
]

export const tipoTampone = [
	"Tampone molecolare (91.12.S)",
	"Tampone molecolare salivare (91.12.X)",
	"Tampone Rapido a lettura facilitata (91.13.S)",
	"Tampone Rapido a lettura manuale (91.13.M)",
]

export const tipoVaccino = [
	"Pfizer-Biontech",
	"AstraZeneca",
	"Johnson & Johnson",
	"Moderna",
	"Curevac",
	"Sputnik V",
	"Covishield",
	"R-CoVID (R-Pharm)",
	"Fiocruz",
]

export const esitiTampone = [
	"POSITIVO",
	"NEGATIVO",
	"NON DICHIARATO",
	"INDETERMINATO",
	"NON PERVENUTO",
	"NON VALIDO",
]

export const rischiEsposizione = [
	"Contatto di Covid/Cluster",
	"Accesso ai servizi sanitari",
	"Cene / Occasioni di incontro",
	"Spazi commerciali",
	"Ristorante / Bar / Palestre",
	"Feste private",
	"Luoghi di culto / Cerimonie",
	"Altro"
]

export const listaParamIsolamento = [
	"NON condivido ambienti con il positivo",
	"NON condivido il letto con il positivo",
	"NON mangio con il positivo",
	"Il positivo ha un bagno dedicato oppure igienizza sempre il bagno dopo averlo usato"
]

export const listaParamIsolamentoCI = [
	"NON condivido ambienti della casa con il positivo, che è isolato in una stanza",
	"NON condivido il letto con i contatti",
	"NON mangio con i contatti",
	"Ho un bagno dedicato oppure igienizzo sempre il bagno dopo averlo usato"
]

export const sexValues = [
	"Maschio",
	"Femmina"
]

export const priorities = [
	"Bassa",
	"Media",
	"Alta",
	"Urgente",
]

export const status = [
	"Aperto",
	"Preso in carico",
	"Risolto",
]

export const filterLocatorOptions = [
	"Torino", "LIMF", "Turin", "Turjn", "Turijn",
	"Trino", "TO", "LIMZ", "Cuneo", "LILE", "Biella",
	"IT4383", "Malpensa", "Linate", "Bergamo", "Bologna",
	"Venezia", "Genova", "Napoli", "Ciampino", "Fiumicino",
	"Torinese", "TORINO", "torino", "Torinese"
]

export const turinVariants = [
	"Torino", "Turin", "Turjn", "Turijn",
	"Trino", "TO", "Torinese", "TORINO", "torino", "Torinese"
]

export const aereoportiCodici = [
	"LIMZ", "LIMC", "LIML", "LIME", "LIPE", "LIPZ", "LIMJ", "LIRN", "LIRA", "LIRF",
]

export const aereoportiCode = {
	"LIMZ": {label: "Cuneo"},
	"LIMC": {label: "Malpensa"},
	"LIML": {label: "Linate"},
	"LIME": {label: "Bergamo"},
	"LIPE": {label: "Bologna"},
	"LIPZ": {label: "Venezia"},
	"LIMJ": {label: "Genova"},
	"LIRN": {label: "Napoli"},
	"LIRA": {label: "Ciampino"},
	"LIRF": {label: "Fiumicino"},
}

export const portiCodici = [
	"ITGOA", "ITPIO", "ITSVN", "ITLIV",
]

export const portiCode = {
	"ITGOA": {label: "Genova"},
	"ITPIO": {label: "Piombinmo"},
	"ITSVN": {label: "Savona"},
	"ITLIV": {label: "Livorno"},
}

export const tipoScuole = [
	"Unità presso istituti penitenziari per minori o per adulti",
	"Istituto Tecnico",
	"Aule staccate",
	"Scuola coordinata",
	"Istituto Comprensivo",
	"Istituto Onnicomprensivo",
	"Istituto Secondario I grado",
	"Circolo Didattico",
	"Sede centrale",
	"Sezione differenziata",
	"Sede associata o annessa",
	"Istituto d'istruzione Secondaria Superiore",
	"Sede staccata",
	"Sezione staccata",
	"Unità presso sede ospedaliera",
	"Succursale",
	"Liceo",
	"Sede di Plesso",
	"Istituto Professionale",
]

export const motiviRientro = [
	"Rientro al proprio domicilio / residenza",
	"Motivi di salute",
	"Assoluta urgenza",
	"Comprovate esigenze lavorative",
	"Comprovati motivi di studio",
	"Turismo",
	"Altro",
	"Ingresso di cittadini",
	"Raggiungere il domicilio / residenza di persona con cui ho relazione affettiva stabile",
]

export const colors = [
	'rgba(255, 99, 132, 1)',
	'rgba(54, 162, 235, 1)',
	'rgba(255, 206, 86, 1)',
	'rgba(75, 192, 192, 1)',
	'rgba(153, 102, 255, 1)',
	'rgba(255, 159, 64, 1)',
	'rgb(189,15,50)',
	'rgb(33,95,131)',
	'rgb(130,155,20)',
	'rgb(159,192,75)',
	'rgb(102,255,250)',
	'rgb(222,114,75)',
]

export const etichetteQuarantena = [
	"IMMUNODEPRESSO",
	"RICOVERATO",
	"SEGUITO DA MEDICO COMPETENTE",
	"SEGUITO DA MMG",
	"DIPENDENTE ASL",
	"ALBERGHI",
	"COMUNITA'",
	"UCRAINA",
]
